import React from 'react'

class Settings extends React.Component {
  render () {
    return (
      <div className="">Settings</div>
    )
  }
}

export default Settings




// WEBPACK FOOTER //
// ./src/views/project/projectComponents/settings/Settings.js